module.exports = __webpack_public_path__ + "static/img/43.ac22300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/43.png
// module id = GTza
// module chunks = 0